<template>
  <div id="app">
    <v-app id="inspire">
      <v-carousel
        hide-controls
        style="height:100%">
        <v-carousel-item
          v-for="(item,i) in items"
          v-bind:src="item.src"
          :key="i">
        </v-carousel-item>
      </v-carousel>
    </v-app>
  </div>
</template>

<script>
import Vue from 'vue'
export default {
  name: 'HomeNew',
  components: {},
  data () {
    return {
      items: [
        {
          src: 'https://cdn.vuetifyjs.com/images/carousel/squirrel.jpg'
        },
        {
          src: 'https://cdn.vuetifyjs.com/images/carousel/sky.jpg'
        },
        {
          src: 'https://cdn.vuetifyjs.com/images/carousel/bird.jpg'
        },
        {
          src: 'https://cdn.vuetifyjs.com/images/carousel/planet.jpg'
        }
      ]
    }
  },
  methods: {
  },
  mounted () {
    Vue.prototype.$api.checkCredentials(this)
  }
}
</script>

<style scoped>
html {
  overflow: hidden;
}
#inspire {
  height: 100vh;
  background-color: black;
  border-style: solid;
  border-color: grey;
}
</style>



// WEBPACK FOOTER //
// src/components/HomeNew.vue